import React, {Component} from 'react';

import AltVendorTable from '../../components/AltVendorTable/AltVendorTable';
import SearchBar from '../../components/SearchAltVend/SearchAltVend';
import {uploadAltVendor, getAltVendByItem, getAltVendByMajor, getAltVendByMinor, getAltVendByAltVendor, getAltVendByPrimaryVendor,
     saveAltVendor, deleteAltVendor, getAltVendByMajorAndMinor, getAltVendByItemAndAltVend, getAltVendorInfo} from '../../../actions/index';
import Modal from '../../components/Modal/Modal';
import NotificationLoading from '../../components/Notification-loading/Notification-loading';
import NotificationSuccess from '../../components/Notification-success/Notification-success';
import NotificationError from '../../components/Notification-error/Notification-error'
import UploadButton from '../../components/UploadButtonAltVendor/UploadButton';
import ModalUnsave from '../../components/Modal-unsave/Modal';
import ModalUnsavePage from '../../components/Modal-unsave-page/Modal';
import ModalErrorData from '../../components/ModalErrorData/ModalErrorData';

import './styles.css'

import * as FileSaver from 'file-saver';


class AltVendor extends Component {

    constructor(props) {
        super(props)   

        this.state= {
            data: [],
            show: false,
            showUnsavedModal: false,
            showUnsavedModalPage: false,
            showNotification: false,
            showNotificationSuccess: false,
            showNotificationEError: false,
            isSaved: false,
            showErrorDataModal: false,
            errorUploadData: []
        }
        this.itemToSend;
        this.itemToDelete;
        this.tableChangeHandle = React.createRef();
    }

    openModal = e => {
        this.setState({
            show: !this.state.show
        });
    }

    openUnsavedModal = () => {
        this.setState({
            showUnsavedModal: !this.state.showUnsavedModal
        });
    }

    openUnsavedModalPage = () => {
        this.setState({
            showUnsavedModalPage: !this.state.showUnsavedModalPage
        });
    }

    openErrorDataModal = () => {
        this.setState({
            showErrorDataModal: !this.state.showErrorDataModal
        });
    }

    onClose = e => {
        this.props.show = false;
    };

    onDataModal = (hasData) => {
        this.openUnsavedModal();
    }

    onGetExcelData = (excelData) => {
        const data = {
            data: excelData
        }
        this.openNotification(true);
        if(data.data[0].hasOwnProperty('__EMPTY')) {
            const message = `Excel file must meet the following criteria: headers must be in row #1 column A, Headers name should match the required and are case sensitive: 
            sku, altVendorNumber, warehouses, nipoBaseCost, nipoCoreCost, itemsAvailable, itemsAnnaulCommitment, unitsPerCase, casesPerTier, tiersPerPallet, companyPOQ, expirationDate, remainingAvailable`
            this.openNotification(false);
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 8000);
            });
        } else {
            uploadAltVendor(data).then(res => {
                this.openNotification(false);
                if(res.data.success == true) {                   
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                        data.uploadedData = true;
                    })
                    this.setState({data: res.data.data});
                } else {
                    const data = res.data.dataError;
                    this.setState({errorUploadData: data}, function() {
                        this.openErrorDataModal();
                    });
                    let message = "Error in some data fields, please check the logs.";
                    this.setState({messageError: message}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 15000);
                    });
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }
    }

    onAddItemData = (data) => {
        uploadAltVendor(data).then(res => {
            this.openNotification(false);
            if (res.data.success){
                this.setState({data: res.data.data});
            } else {
                const errors = [];
                res.data.dataError.forEach(function (item, index) {
                    errors.push(item.message + " ");
                });
                this.setState({messageError: errors}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 15000);
                });
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    saveAltVendor = () => {
        if(this.state.data.length > 0) {
            const userId = sessionStorage.getItem("uId");
            const data = {
                audit: {userId: userId},
                data: this.itemToSend? this.itemToSend: this.state.data
            };
            this.openNotification(true);
            saveAltVendor(data).then(res => {
                if(res.data.success == true) { 
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                    })
                    this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                    this.setState({isSaved: true});
                    this.openNotification(false);
                    this.openNotificationSuccess(true);
                    setTimeout(() => { this.openNotificationSuccess(false) }, 2000);
                } else {
                    this.setState({messageError: res.data.messages[0].text}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 2000);
                    });
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401) message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }   
    }

    deleteAltVendor = () => {
        if(this.itemToDelete) {
            let idsToDelete = this.itemToDelete.map(data => data.masterIndex);
            let result = this.state.data.filter(data => idsToDelete.indexOf(data.masterIndex) === -1)
            this.setState({data: result});
            const data = {
                data: this.itemToDelete
            };
            deleteAltVendor(data).then(res => {
                this.triggerDelete();
                this.itemToDelete = [];
            }).catch(err => {
                let message;
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }  
    }

    triggerSearchItem = (item) => {
        this.openNotification(true);
        if(item.length == 0) {
            getAltVendorInfo().then(res => {
                this.openNotification(false);
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        } else {
            getAltVendByItem(item).then(res => {
                this.openNotification(false);
                if(res.data.success == false) {  
                    this.setState({messageError: res.data.messages[0].text}, function() {
                        this.openNotificationError(true); 
                        setTimeout(() => { this.openNotificationError(false) }, 2000);
                    });
                } else {
                    res.data.data.map((data,index) => {
                        data.masterIndex = index;
                    })
                    this.setState({data: res.data.data, filterItem: null,filterVendor: null});
                }
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        }
    }

    triggerSearchMajor = (major) => {
        this.openNotification(true);
        getAltVendByMajor(major).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    triggerSearchMinor = (minor) => {
        this.openNotification(true);
        getAltVendByMinor(minor).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    triggerSearchPrimaryVend = (primary) => {
        this.openNotification(true);
        getAltVendByPrimaryVendor(primary).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    triggerSearchAltVend = (alt) => {
        this.openNotification(true);
        getAltVendByAltVendor(alt).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    triggerSearchMajorAndMinor = (major, minor) => {
        this.openNotification(true);
        getAltVendByMajorAndMinor(major, minor).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    triggerSearchItemAndAltVend = (item, altVend) => {
        this.openNotification(true);
        getAltVendByItemAndAltVend(item, altVend).then(res => {
            this.openNotification(false);
            if(res.data.success == false) {  
                this.setState({messageError: res.data.messages[0].text}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 2000);
                });
            } else {
                res.data.data.map((data,index) => {
                    data.masterIndex = index;
                })
                this.setState({data: res.data.data, filterItem: null,filterVendor: null});
            }
        }).catch(err => {
            let message;
            this.openNotification(false);
            if(err.response.status === 503)  message = err.response.data.errors[0].title
            if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
            this.setState({messageError: message}, function() {
                this.openNotificationError(true); 
                setTimeout(() => { this.openNotificationError(false) }, 5000);
            });
        });
    }

    filterItem = (item) => {
        this.setState({filterItem: item, type: "item"});
    }

    filterAltVendor = (vendor) => {
        this.setState({filterVendor: vendor, type: "vendor"});
    }

    getItemToSend = (item) => {
        this.itemToSend = item;
    }

    getItemToDelete = (item) => {
        this.itemToDelete = item;
    }

    CloseWindow = () => {
        if(this.state.isSaved === false && this.state.data.length > 0) {
            this.openUnsavedModalPage();
        } else {
            this.discardChangesPage(true);   
        } 
    }

    triggerCancel = () => {
        this.tableChangeHandle.current.onCancel();
    }

    triggerExport = () => {
        this.openNotification(true);
        if(this.state.data.length == 0) {
            getAltVendorInfo().then(res => {
                this.openNotification(false);
                this.tableChangeHandle.current.onExportToExcel(res.data.data);
            }).catch(err => {
                let message;
                this.openNotification(false);
                if(err.response.status === 503)  message = err.response.data.errors[0].title
                if(err.response.status === 401)  message = 'The authentication token expired, please re-login and try again.'
                this.setState({messageError: message}, function() {
                    this.openNotificationError(true); 
                    setTimeout(() => { this.openNotificationError(false) }, 5000);
                });
            });
        } else {
            this.openNotification(false);
            this.tableChangeHandle.current.onExportToExcel(null);
        } 
    }

    triggerDelete = () => {
        this.tableChangeHandle.current.onDeleteData();
    }

    openNotification = (show) => {
        this.setState({
            showNotification: show
        });
    }

    openNotificationSuccess = (show) => {
        this.setState({
            showNotificationSuccess: show
        });
    }

    openNotificationError = (show) => {
        this.setState({
            showNotificatioError: show
        });
    } 
    
    discardChangesPage = (discard) => {
        this.props.history.push("/");  
    }

    discardChanges = (discard) => {
        this.openUnsavedModal();
        this.openModal();
    }

    saveModalPage = (save) => {
        this.openUnsavedModalPage();
        this.saveAltVendor();
    }

    createTemplateExcel = async () => {
        const XLSX = await import("xlsx");
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const dataTemplate = [{
            "sku": "",
            "altVendorNumber": "",
            "warehouses": "",
            "nipoBaseCost": "",
            "nipoCoreCost": "",
            "itemsAvailable": "",
            "itemsAnnaulCommitment": "",
            "unitsPerCase": "",
            "casesPerTier": "",
            "tiersPerPallet": "",
            "companyPOQ": "",
            "expirationDate": "",
            "remainingAvailable": "",
            "cancel": "",
        }]


        const ws = XLSX.utils.json_to_sheet(dataTemplate);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, 'Template-File-ALT-VENDOR' + fileExtension);
    }

    
    render() {
        return (
            <div className="container-fluid">
                <h3 className="page-title">Alternate Vendor Maintenance</h3>
                <SearchBar  triggerSearchItem={this.triggerSearchItem}  triggerSearchMajor={this.triggerSearchMajor}  triggerSearchMinor={this.triggerSearchMinor}  
                triggerSearchPrimaryVend={this.triggerSearchPrimaryVend}  triggerSearchAltVend={this.triggerSearchAltVend} filterItem={this.filterItem}  
                filterAltVendor={this.filterAltVendor} triggerSearchMajorAndMinor={this.triggerSearchMajorAndMinor} triggerSearchItemAndAltVend={this.triggerSearchItemAndAltVend}/>
                <Modal onClose={this.openModal} show={this.state.show} onAddItemData={this.onAddItemData} onData={this.onDataModal} openNotification={this.openNotification}/>
                <AltVendorTable responseData={this.state.data} itemSend={this.getItemToSend} itemDelete={this.getItemToDelete} filterItem={this.state.filterItem} 
                filterAltVendor={this.state.filterVendor} ref={this.tableChangeHandle} type={this.state.type}/>
                <div className="actionss-container">
                    <button type="button" className="btn btn-warning actions-button btn-sm" onClick={this.CloseWindow}>Close</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.createTemplateExcel}>Create Template</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.triggerExport}>Export</button>
                    <button type="button" className="btn btn-warning actions-button vendor btn-sm" onClick={this.openModal}>Add Vendor</button>
                    <UploadButton  onGetExcelData={this.onGetExcelData} openNotification={this.openNotification}/>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.triggerCancel}>Cancel</button>
                    <button type="button" className="btn btn-warning actions-button  btn-sm" onClick={this.deleteAltVendor}>Delete</button>
                    <button type="button" className="btn btn-warning actions-button btn-sm" onClick={this.saveAltVendor}>Save</button>
                </div>
                <NotificationLoading show={this.state.showNotification} onClose={this.openNotification}/>
                <NotificationError show={this.state.showNotificatioError} onClose={this.openNotificationError} message={this.state.messageError}/>
                <NotificationSuccess show={this.state.showNotificationSuccess} onClose={this.openNotificationSuccess}/>
                <ModalUnsave showw={this.state.showUnsavedModal} onClose={this.openUnsavedModal} onDiscard={this.discardChanges}/>
                <ModalUnsavePage show={this.state.showUnsavedModalPage} onClose={this.openUnsavedModalPage} onDiscard={this.discardChangesPage} onSave={this.saveModalPage}/>
                <ModalErrorData show={this.state.showErrorDataModal} onClose={this.openErrorDataModal} data={this.state.errorUploadData}/>
            </div>
        );
    }

}

export default AltVendor;